export default "../fonts/akzidgrtskpromed-webfont.595cbe663098537ee5f78f7a587d0b17.ttf";